import { defineComponent as _defineComponent } from 'vue'
import { Ref, computed, inject, ref } from 'vue';
import { useRouter } from 'vue-router/composables';
import {
  BaseText,
  Heading,
  ContentDisplay,
  ChipContext
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { IPortfolioDistributionResponse } from '@/modules/wallet-builder/src/services/types/models/IBffInvestments';


export default /*#__PURE__*/_defineComponent({
  __name: 'AboutStrategy',
  setup(__props) {

const router = useRouter();

const injectedPortfolioDistribution = inject<IPortfolioDistributionResponse>(
  'portfolioDistribution'
);
const portfolioDistribution = ref<IPortfolioDistributionResponse | undefined>(
  injectedPortfolioDistribution
);

const riskCategoryColors: { [key: string]: NebraskaColors } = {
  'Muito baixo': NebraskaColors.riskLow,
  Baixo: NebraskaColors.riskLow,
  Médio: NebraskaColors.riskMedium,
  Alto: NebraskaColors.riskHigh,
  'Muito alto': NebraskaColors.riskHigh
};

function goToCosts() {
  router.push({ name: 'costs' });
}

const isPortfolioDistributionLoading = inject(
  'isPortfolioDistributionLoading'
) as Ref<boolean>;

const shouldShowFeesMessage = computed(() => {
  return portfolioDistribution?.value?.portfolio?.shouldShowFeesMessage;
});

const riskTitle = computed(() => {
  return portfolioDistribution?.value?.portfolio?.riskTitle;
});

const riskDescription = computed(() => {
  return portfolioDistribution?.value?.portfolio?.riskDescription;
});

const portfolioStategyDescription = computed(() => {
  return portfolioDistribution?.value?.portfolio?.strategyDescription;
});

const isCustomPortfolio = computed(() => {
  return portfolioDistribution?.value?.portfolio?.isCustom;
});

const riskCategory = computed(() => {
  return portfolioDistribution?.value?.portfolio?.riskCategory;
});

return { __sfc: true,router, injectedPortfolioDistribution, portfolioDistribution, riskCategoryColors, goToCosts, isPortfolioDistributionLoading, shouldShowFeesMessage, riskTitle, riskDescription, portfolioStategyDescription, isCustomPortfolio, riskCategory, BaseText, Heading, ContentDisplay, ChipContext, NebraskaColors }
}

})